export var ValidateSegmentErrorType;
(function (ValidateSegmentErrorType) {
    ValidateSegmentErrorType["SEGMENT"] = "segment";
    ValidateSegmentErrorType["FIELD"] = "field";
})(ValidateSegmentErrorType || (ValidateSegmentErrorType = {}));
//# sourceMappingURL=validate-segment.types.js.map